import React from "react";

const StatusIcon = ({ type }) => {
  const icons = {
    success: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
      >
        <path
          id="Path_1451"
          data-name="Path 1451"
          d="M-.308,4.116a15.073,15.073,0,0,0,15-14.993,15.1,15.1,0,0,0-15-15.007,15.085,15.085,0,0,0-15,15.007A15.073,15.073,0,0,0-.308,4.116ZM-2.245-3.273a1.913,1.913,0,0,1-1.493-.775l-4.12-4.964a1.633,1.633,0,0,1-.431-1.1,1.464,1.464,0,0,1,1.464-1.478,1.551,1.551,0,0,1,1.249.646l3.287,4.075,6.33-10.072a1.512,1.512,0,0,1,1.292-.832,1.464,1.464,0,0,1,1.536,1.392,2.186,2.186,0,0,1-.388,1.076L-.8-4.09A1.73,1.73,0,0,1-2.245-3.273Z"
          transform="translate(15.308 25.884)"
          fill="#9dd838"
        />
      </svg>
    ),
    error: (
      <svg
        width="31"
        height="31"
        viewBox="0 0 31 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Group 12848">
          <circle
            id="Ellipse 611"
            opacity="0.2"
            cx="15.5"
            cy="15.3894"
            r="15"
            fill="#D53943"
          />
          <g id="Group 12847">
            <path
              id="Line 36 (Stroke)"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.5293 6.3894C16.3577 6.3894 17.0293 7.06098 17.0293 7.8894V16.6167C17.0293 17.4451 16.3577 18.1167 15.5293 18.1167C14.7009 18.1167 14.0293 17.4451 14.0293 16.6167V7.8894C14.0293 7.06098 14.7009 6.3894 15.5293 6.3894Z"
              fill="#D53943"
            />
            <path
              id="Line 37 (Stroke)"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.5293 21.4197C16.3577 21.4197 17.0293 22.0913 17.0293 22.9197L17.0293 22.8894C17.0293 23.7178 16.3577 24.3894 15.5293 24.3894C14.7009 24.3894 14.0293 23.7178 14.0293 22.8894L14.0293 22.9197C14.0293 22.0913 14.7009 21.4197 15.5293 21.4197Z"
              fill="#D53943"
            />
          </g>
        </g>
      </svg>
    ),
    alreadyPaid: (
      <svg
        width="60"
        height="61"
        viewBox="0 0 60 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="30" cy="30.6113" r="30" fill="#8CC63F" fillOpacity="0.1" />
        <path
          d="M16.5 30.7449L23.4338 39.2602C24.3342 40.3659 26.0229 40.3659 26.9233 39.2602L43.5 18.9028"
          stroke="#8CC63F"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  };

  return icons[type] || icons.error;
};

export default StatusIcon;
